import React, { Component, ErrorInfo, ReactNode } from 'react';

import styles from './error.module.css';

interface ErrorProps {
  children?: ReactNode;
  error?: boolean;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorProps, State> {
  public state: State

  constructor(props: ErrorProps) {
    super(props);
    this.state = {
      hasError: props.error || false
    };
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError || this.props.error) {
      return (
          <div className={`${styles.errorContainer}`}>
            <svg className={`${styles.errorContainerSvg}`}>
              <path
                d="M12.0802 12.0825C19.8728 4.29075 30.231 0 41.25 0C63.996 0 82.5 18.504
              82.5 41.25C82.5 52.269 78.21 62.6287 70.4197 70.4212C62.6302 78.21 52.2735
              82.5 41.2575 82.5H41.25C18.504 82.5 0 63.996 0 41.25C0 30.2325 4.29 19.875
              12.0802 12.0825ZM75 41.25C75 22.6395 59.8605 7.5 41.25 7.5C32.235 7.5 23.76
              11.01 17.385 17.385C11.01 23.76 7.5 32.235 7.5 41.25C7.5 59.8605 22.641 75
              41.2515 75H41.2575C50.2107 75.0248 58.8016 71.4663 65.115 65.118C71.49 58.743
              75 50.2665 75 41.25ZM36.75 19.5V31.6073L38.3978 48H43.7985L45.75
              31.6073V19.5H36.75ZM36.75 63V54H45.75V63H36.75Z"/>
            </svg>
            <div className={`${styles.errorTextContent}`}>
              <h1 className={`${styles.errorMainText}`}>This page cannot be found.</h1>
              <div className={`${styles.errorSubText}`}>The requested URL moved, does not exist or is no longer valid</div>
            </div>
          </div>
      )
    }
    else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
